// src/views/PrivacyPage.jsx - VERSION CORRIGÉE (HTML direct)
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PublicTopBar from "./PublicTopBar";
import Footer from "../components/Footer";
import { publicSiteWebService } from "../services/publicSiteWebService";

export default function PrivacyPage() {
  const [loading, setLoading] = useState(true);
  const [documentData, setDocumentData] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const data = await publicSiteWebService.getDocumentLegal('confidentialite');
        setDocumentData(data);
      } catch (err) {
        setDocumentData(null);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  if (loading) {
    return (
      <div className="privacy-page">
        <PublicTopBar />
        <div className="loader-container">
          <div className="loader-spinner" />
        </div>
        <Footer />
        <style>{`
          .loader-container { min-height: 60vh; display: flex; justify-content: center; align-items: center; }
          .loader-spinner { width: 48px; height: 48px; border: 4px solid #e2e8f0; border-top-color: #004080; border-radius: 50%; animation: spin 0.8s linear infinite; }
          @keyframes spin { to { transform: rotate(360deg); } }
        `}</style>
      </div>
    );
  }

  const content = documentData?.contenu || "";
  const version = documentData?.version || "1.0";
  const datePub = documentData?.date_publication 
    ? new Date(documentData.date_publication).toLocaleDateString("fr-FR", {
        day: "2-digit", month: "2-digit", year: "numeric"
      })
    : "Date inconnue";

  return (
    <>
      <style>{`
        :root {
          --n-bg: #f8f9fa;
          --n-card: #ffffff;
          --n-ink: #0f1b2d;
          --n-mut: #64748b;
          --n-b: #e8e8ee;
          --n-b2: #d0d0da;
          --pr: #004080;
          --pr-lt: #0066CC;
          --pr-bg: #e6eef7;
        }

        .privacy-page {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          background: var(--n-bg);
        }

        .privacy-hero {
          flex: 1;
          padding: 120px 20px 40px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .privacy-content {
          max-width: 900px;
          width: 100%;
          animation: fadeInUp 0.6s ease;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .privacy-header {
          text-align: center;
          margin-bottom: 32px;
        }

        .privacy-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: var(--pr-bg);
          color: var(--pr);
          padding: 6px 16px;
          border-radius: 20px;
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 16px;
        }

        .privacy-title {
          font-size: 38px;
          font-weight: 700;
          color: var(--n-ink);
          margin: 0 0 8px;
        }

        .privacy-title span { color: var(--pr); }

        .privacy-meta {
          font-size: 14px;
          color: var(--n-mut);
          margin: 0 0 20px;
        }

        .privacy-meta span { margin: 0 8px; }

        .privacy-divider {
          width: 60px;
          height: 3px;
          background: linear-gradient(90deg, var(--pr), var(--pr-lt));
          border-radius: 2px;
          margin: 0 auto 20px;
        }

        .privacy-body {
          background: var(--n-card);
          border: 1px solid var(--n-b);
          border-radius: 16px;
          padding: 40px 48px;
          margin-bottom: 28px;
          box-shadow: 0 2px 12px rgba(0,0,0,0.04);
        }

        .privacy-body h1 {
          font-size: 28px;
          font-weight: 700;
          color: var(--n-ink);
          margin: 0 0 16px;
        }

        .privacy-body h2 {
          font-size: 22px;
          font-weight: 700;
          color: var(--n-ink);
          margin: 28px 0 12px;
          padding-bottom: 8px;
          border-bottom: 2px solid var(--pr-bg);
        }

        .privacy-body h3 {
          font-size: 18px;
          font-weight: 600;
          color: var(--n-ink);
          margin: 20px 0 10px;
        }

        .privacy-body p {
          font-size: 15px;
          line-height: 1.8;
          color: var(--n-ink);
          margin: 0 0 12px;
        }

        .privacy-body ul {
          padding-left: 24px;
          margin: 8px 0 16px;
        }

        .privacy-body li {
          font-size: 15px;
          line-height: 1.7;
          color: var(--n-ink);
          margin-bottom: 6px;
        }

        .privacy-body strong {
          color: var(--pr);
        }

        .privacy-body hr {
          margin: 24px 0;
          border: none;
          border-top: 1px solid var(--n-b);
        }

        .privacy-empty {
          text-align: center;
          padding: 60px 20px;
          color: var(--n-mut);
          font-size: 15px;
        }

        .privacy-empty i {
          font-size: 32px;
          display: block;
          margin-bottom: 8px;
        }

        .privacy-actions {
          display: flex;
          justify-content: center;
          gap: 12px;
          flex-wrap: wrap;
        }

        .privacy-cta {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: var(--pr);
          color: #fff;
          border: none;
          border-radius: 12px;
          padding: 14px 28px;
          font-size: 14px;
          font-weight: 600;
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .privacy-cta:hover {
          background: var(--pr-lt);
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(0,64,128,0.3);
          color: #fff;
        }

        .privacy-cta-secondary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: transparent;
          color: var(--pr);
          border: 2px solid var(--pr);
          border-radius: 12px;
          padding: 12px 26px;
          font-size: 14px;
          font-weight: 600;
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .privacy-cta-secondary:hover {
          background: var(--pr);
          color: #fff;
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(0,64,128,0.15);
        }

        .loader-container { min-height: 60vh; display: flex; justify-content: center; align-items: center; }

        .loader-spinner {
          width: 48px;
          height: 48px;
          border: 4px solid #e2e8f0;
          border-top-color: #004080;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }

        @media (max-width: 768px) {
          .privacy-title { font-size: 30px; }
          .privacy-hero { padding: 100px 16px 30px; }
          .privacy-body { padding: 24px 20px; }
        }

        @media (max-width: 480px) {
          .privacy-title { font-size: 24px; }
          .privacy-hero { padding: 90px 16px 20px; }
          .privacy-body { padding: 16px; }
          .privacy-body h1 { font-size: 22px; }
          .privacy-body h2 { font-size: 18px; }
          .privacy-body p, .privacy-body li { font-size: 14px; }
          .privacy-cta, .privacy-cta-secondary { width: 100%; justify-content: center; }
        }
      `}</style>

      <div className="privacy-page">
        <PublicTopBar />

        <section className="privacy-hero">
          <div className="privacy-content">
            <div className="privacy-header">
              <div className="privacy-badge">
                <i className="ti ti-lock"></i>
                <span>Confidentialité</span>
              </div>

              <h1 className="privacy-title">
                Politique de <span>Confidentialité</span>
              </h1>

              <p className="privacy-meta">
                Version {version} <span>•</span> Mise à jour le {datePub}
              </p>

              <div className="privacy-divider"></div>
            </div>

            <div className="privacy-body">
              {content ? (
                <div dangerouslySetInnerHTML={{ __html: content }} />
              ) : (
                <div className="privacy-empty">
                  <i className="ti ti-file-off"></i>
                  Le contenu de cette page n'est pas encore disponible.
                </div>
              )}
            </div>

            <div className="privacy-actions">
              <Link to="/" className="privacy-cta">
                <i className="ti ti-arrow-left"></i>
                Retour à l'accueil
              </Link>
              <Link to="/contact" className="privacy-cta-secondary">
                <i className="ti ti-mail"></i>
                Nous contacter
              </Link>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}